import { defineMessages } from "react-intl";

export const scope = "pages.MemberDepositPage";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Dirección { ticker } para { name }",
  },
  continueButton: {
    id: `${scope}.continueButton`,
    defaultMessage: "CONTINUAR",
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: "CANCELAR",
  },
  buttonLabel: {
    id: `${scope}.buttonLabel`,
    defaultMessage: "DEPOSITAR A OTRA MONEDA",
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: "Seleccionar moneda",
  },
});
